var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as ab_service from './generated/index';
import '@zocdoc/polyfill';
var BASE_PATH = 'https://api-private.east.zocdoccloud.net';
var ABServiceClient = (function () {
    function ABServiceClient(_a) {
        var projectId = _a.projectId, _b = _a.fetch, fetch = _b === void 0 ? fetchWithRetries : _b, _c = _a.basePath, basePath = _c === void 0 ? BASE_PATH : _c, _d = _a.timeoutInMillis, timeoutInMillis = _d === void 0 ? 1000 : _d;
        this.generatedClient = new ab_service.DefaultApi(fetch, basePath);
        this.projectId = projectId;
        this.timeoutInMillis = timeoutInMillis;
    }
    ABServiceClient.prototype.setAssignmentsWithDefault = function (_a) {
        var attributes = _a.attributes, experiments = _a.experiments, requestOriginUrl = _a.requestOriginUrl, userAgent = _a.userAgent;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var error_1, assignments, _i, experiments_1, experiment;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.callWithTimeout(function () { return _this.generatedClient.setAssignments({
                                assignmentData: {
                                    attributes: attributes,
                                    experiments: experiments,
                                    projectId: _this.projectId,
                                    requestOriginUrl: requestOriginUrl,
                                    userAgent: userAgent,
                                }
                            }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_1 = _a.sent();
                        console.warn("Error setting assignments on AB service, falling back to default. " + JSON.stringify(error_1));
                        return [3 /*break*/, 3];
                    case 3:
                        assignments = {};
                        for (_i = 0, experiments_1 = experiments; _i < experiments_1.length; _i++) {
                            experiment = experiments_1[_i];
                            assignments[experiment.experimentId] = experiment.defaultAssignment;
                        }
                        return [2 /*return*/, { assignments: assignments }];
                }
            });
        });
    };
    ABServiceClient.prototype.setAssignmentWithDefault = function (_a) {
        var attributes = _a.attributes, experiment = _a.experiment, requestOriginUrl = _a.requestOriginUrl, userAgent = _a.userAgent;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var result, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.callWithTimeout(function () { return _this.generatedClient.setAssignments({
                                assignmentData: {
                                    attributes: attributes,
                                    experiments: [experiment],
                                    projectId: _this.projectId,
                                    requestOriginUrl: requestOriginUrl,
                                    userAgent: userAgent,
                                }
                            }); })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, { isBot: result.isBot, assignment: result.assignments[experiment.experimentId] }];
                    case 2:
                        error_2 = _a.sent();
                        console.warn("Error setting assignments on AB service, falling back to default. " + JSON.stringify(error_2));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, { assignment: experiment.defaultAssignment }];
                }
            });
        });
    };
    ABServiceClient.prototype.logAssignments = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.callWithTimeout(function () { return _this.generatedClient.logAssignments(params); })];
            });
        });
    };
    ABServiceClient.prototype.trackConversion = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.callWithTimeout(function () { return _this.generatedClient.trackConversion(params); })];
            });
        });
    };
    ABServiceClient.prototype.logConversions = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.callWithTimeout(function () { return _this.generatedClient.logConversions(params); })];
            });
        });
    };
    ABServiceClient.prototype.updateDatafile = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.callWithTimeout(function () { return _this.generatedClient.updateDatafile(params); })];
            });
        });
    };
    ABServiceClient.prototype.getProjectExperiments = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.callWithTimeout(function () { return _this.generatedClient.getProjectExperiments(params); })];
            });
        });
    };
    ABServiceClient.prototype.setSEOAssignments = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.callWithTimeout(function () { return _this.generatedClient.setSEOAssignments({ assignmentData: params }); })];
            });
        });
    };
    ABServiceClient.prototype.timeoutPromise = function (value) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(new Error("Request timed out after " + value + " ms."));
            }, value);
        });
    };
    ABServiceClient.prototype.callWithTimeout = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.race([this.timeoutPromise(this.timeoutInMillis), request()])];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return ABServiceClient;
}());
export { ABServiceClient };
